import { combineReducers } from 'redux';

// Layout
import Layout from './layout/reducer';
import Dashboard from './dashboard/reducer';

//login
import login from './auth/login/reducer';

// Brand
import brand from './brand/reducer';

//register
import register from './auth/register/reducer';

// User Profile
import profile from './auth/profile/reducer';

// Forget Password
import forgetPassword from './auth/forgetpwd/reducer';

//Invoices
import Invoices from './invoices/reducer';

// CRUD CLIENTES
import clients from './client/reducer';

import Traceabilities from './traceabilities/reducer';

import ApiList from './apiList/reducer';

import itemDefinitions from './itemDefinitions/reducer';

import DashboardPW from './dashboardPW/reducer';
import salesOrders from './salesOrders/reducer';
import shipments from './shipments/reducer';
import warehouseReceipts from './warehouseReceipts/reducer';
import cargoRelease from './cargoRelease/reducer';
import purchaseOrders from './purchaseOrders/reducer';
import Commodity from './Commodity/reducer';
import POcomparison from './POcomparison/reducer';
import Entities from './Entities/reducer';

import InactiveUsersReduce from './inactiveUsers/reducer';

//Invoices
import tableViews from './tableViews/reducer';

import Milestones from './milestones/reducer';

import SavedSearches from './SavedSearches/reducer';
import Permissions from './Permissions/reducer';
import Tasks from './Tasks/reducer';
import Roles from './Roles/reducer';
import Users from './Users/reducer';
import ConfigTasks from './ConfigTasks/reducer';
import SyncConfiguration from './syncConfig/reducer';
import pickupOrders from './pickupOrders/reducer';
import SummaryImport from './summaryImport/reducer';
import loadFiles from './LoadFiles/reducer';
import DashboardHL from './dashboardHl/reducer';
import Attachments from './attachments/reducer';
import cargoReleaseCreation from './cargoReleaseCreation/reducer';
import RegistrySetRequest from './RegistrySetRequest/reducer';
import Documents from './documents/reducer';
import ConfigPOD from './configReportPOD/reducer';
import invoicesList from './invoicesList/reducer';

const rootReducer = combineReducers({
  // public
  ApiList,
  brand,
  clients,
  Dashboard,
  DashboardPW,

  forgetPassword,
  Invoices,
  Layout,
  login,
  profile,
  register,
  Traceabilities,
  itemDefinitions,
  InactiveUsersReduce,

  salesOrders,
  shipments,
  warehouseReceipts,
  cargoRelease,
  purchaseOrders,
  pickupOrders,
  Commodity,
  invoicesList,
  POcomparison,
  Entities,

  tableViews,
  Milestones,
  SavedSearches,
  Permissions,
  Tasks,
  Roles,
  Users,
  ConfigTasks,
  SyncConfiguration,
  loadFiles,
  SummaryImport,
  Attachments,
  DashboardHL,
  cargoReleaseCreation,
  RegistrySetRequest,
  Documents,
  ConfigPOD

});

export default rootReducer;
